var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-294.65)",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6 297.65v1h-2v2h-1v8h1v2h2v1h8v-1h2v-2h1v-8h-1v-2h-2v-1z",
    fillOpacity: 0.27451,
    opacity: 0.544
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.91 297.99a6.6574 6.6574 89.506 0 0-6.568 6.7468 6.6574 6.6574 89.506 0 0 6.7468 6.568 6.6574 6.6574 89.506 0 0 6.568-6.7468 6.6574 6.6574 89.506 0 0-6.7468-6.568zm0.089396 0.83218a5.8252 5.8252 0 0 1 5.8252 5.8252 5.8252 5.8252 0 0 1-5.8252 5.8252 5.8252 5.8252 0 0 1-5.8252-5.8252 5.8252 5.8252 0 0 1 5.8252-5.8252z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4.9792,
    y: 289.67,
    width: 29.958,
    height: 29.958,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.041609
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 304.65,
    rx: 14.979,
    ry: 14.979,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.041609
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.21753 0 0 .20858 -.94907 3.7293)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.398 58.564)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(.88934)",
    r: 8,
    fill: "#0079B5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.1s",
    dur: "0.8s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "1 1;0.1 0.1"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.598 74.39)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(36)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(.83934)",
    r: 8,
    fill: "#0079B5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.2s",
    dur: "0.8s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "1 1;0.1 0.1"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.061 76.185)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(.78934)",
    r: 8,
    fill: "#0079B5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.3s",
    dur: "0.8s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "1 1;0.1 0.1"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.77 64.657)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(108)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(.73934)",
    r: 8,
    fill: "#0079B5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.4s",
    dur: "0.8s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "1 1;0.1 0.1"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.678 47.6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(.68934)",
    r: 8,
    fill: "#0079B5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.5s",
    dur: "0.8s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "1 1;0.1 0.1"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.507 32.433)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(.63934)",
    r: 8,
    fill: "#0079B5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.6s",
    dur: "0.8s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "1 1;0.1 0.1"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.699 23.596)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(.98934)",
    r: 8,
    fill: "#0079B5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.7s",
    dur: "0.8s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "1 1;0.1 0.1"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.15 36.48)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-36)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "scale(.93934)",
    r: 8,
    fill: "#0079B5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.8s",
    dur: "0.8s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "1 1;0.1 0.1"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleLoader);
export default __webpack_public_path__ + "static/media/circle_loader.b6996cef6c8dfa4de46eb2d71cc4a6b4.svg";
export { ForwardRef as ReactComponent };